import { Component } from '@angular/core';

@Component({
  templateUrl: './root.component.html',
})
export class RootComponent {
}
